import { toast, ToastContent, ToastOptions } from 'react-toastify';

const toastTrigger = (msg: ToastContent, options?: ToastOptions & { stacked?: boolean }) => {
  const { type, ...rest } = options || {};

  let _msg = msg;
  if (typeof msg === 'string') {
    _msg = <div dangerouslySetInnerHTML={{ __html: msg }} />;
  }
  return toast(_msg, {
    className: `${options?.className || ''} ${type}-toast`,
    type,
    ...rest,
  });
};

export default toastTrigger;
